import React, { FC } from 'react'
import * as R from 'remeda'
import { Box, Flex } from '../../new/core-components/box'
import { Checkbox } from '../checkbox'
import { getCategoryControlData } from './hooks/useSelectWithCategoryControl'
import { OptionProps } from './types'

interface Props {
  isMultiSelect?: boolean
  item: React.ReactElement<OptionProps>
  multiSelectValue: string[]
  optionsProps: OptionProps[]
}

export const SearchItemInner: FC<Props> = props => {
  const { item, isMultiSelect, multiSelectValue, optionsProps } = props
  const { isCategoryControl, isCategoryLabel, value: optionValue, category, disabled } = item.props

  if (isCategoryControl) {
    const { isCategoryControlChecked } = getCategoryControlData({
      category,
      isCategoryControl,
      optionsProps,
      multiSelectValue,
    })

    return (
      <Flex w='100%' alignItems='center'>
        {isMultiSelect && (
          <Checkbox checked={isCategoryControlChecked} onChange={R.doNothing()} noInput />
        )}
        <Box w='100%' pl={isMultiSelect ? 4 : undefined}>
          {item}
        </Box>
      </Flex>
    )
  }

  if (isMultiSelect && !isCategoryLabel) {
    return (
      <Flex>
        <Checkbox
          checked={multiSelectValue.includes(optionValue)}
          onChange={R.doNothing()}
          disabled={disabled}
          noInput
        />
        <Box pl={4} w='100%' flex={1}>
          {item}
        </Box>
      </Flex>
    )
  }

  return item
}
